<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" />
        <table-header :title="$t('employee.name')" :minWidth="180" />
        <table-header :title="$t('employee.email')" :minWidth="180" />
        <table-header :title="$t('employee.phone')" :minWidth="150" />
        <table-header :title="$t('employee.jobTitle')" :minWidth="100" />
        <table-header :title="$t('employee.storeName')" :minWidth="100" />
        <table-header :title="$t('common.action')" :minWidth="100" />
      </template>
      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.name }}</table-cell>
        <table-cell>{{ row.email }}</table-cell>
        <table-cell>{{ formatPhoneNumber(row.phone) }}</table-cell>
        <table-cell>{{ row.role }}</table-cell>
        <table-cell>{{ row.store.name }}</table-cell>
        <table-cell>
          <i class="el-icon-view icon" @click="handleViewDetail(row.id)" />
          <i
            v-if="userInfo.type === ERolAdmin.ADMIN"
            class="el-icon-delete icon"
            @click="handleOpenDeleteDialog(row.id)"
          />
        </table-cell>
      </template>
    </table-component>

    <modal-delete
      :title="null"
      :content="$t('employee.confirmDelete')"
      :openDeleteDialog="openDeleteDialog"
      :deleteLoading="deleteEmployeeLoading"
      @handleCloseDialog="handleCloseDeleteDialog"
      @handleConfirm="handleDeleteEmployee"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  handleError,
  notifyMessage,
  redirectRouter,
  formatPhoneNumber,
} from '@/helper';
import { employeeService } from '@/services/employee.service';
import { LIMIT, PAGE } from '@/constants/common';
import * as pageRouter from '@/constants/pageRouter';
import { ERolAdmin } from '@/enums/user';

const ModalDelete = () => import('@/components/Dialog/DialogConfirm.vue');

export default {
  name: 'TableListEmployee',
  components: { ModalDelete },
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  data() {
    return {
      ERolAdmin,
      deleteEmployeeLoading: false,
      employeeIdSelected: null,
      openDeleteDialog: false,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('employee', ['employee']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    formatPhoneNumber,
    ...mapActions('employee', ['getEmployeeList']),
    handleOpenDeleteDialog(employeeId) {
      this.employeeIdSelected = employeeId;
      this.openDeleteDialog = true;
    },
    handleCloseDeleteDialog() {
      this.openDeleteDialog = false;
    },
    handleViewDetail(id) {
      redirectRouter({
        path: `/employees/${id}`,
        query: {
          name: this.$route.query.name,
          store: this.$route.query.store,
          page: this.$route.query.page,
        },
      });
    },
    async handleDeleteEmployee() {
      this.deleteEmployeeLoading = true;

      await employeeService
        .delete(this.employeeIdSelected)
        .then(() => {
          const employeeLength = this.employee.data.length - 1;

          this.getEmployeeList({
            name: this.$route.query.name,
            store: this.$route.query.store,
            page:
              employeeLength === 0 && +this.$route.query.page > 1
                ? +this.$route.query.page - 1
                : this.$route.query.page || PAGE,
            limit: LIMIT,
          });

          redirectRouter({
            path: pageRouter.EMPLOYEE,
            query: {
              ...this.$route.query,
              page:
                employeeLength === 0 && +this.$route.query.page > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page,
            },
          });
          notifyMessage(this.$t('common.deleteSuccess'), 'success');
          this.openDeleteDialog = false;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.deleteEmployeeLoading = false;
        });
    },
  },
};
</script>
